import Vue from 'vue'

// This is the top-most errorHandler used in the root Vue instance
export function errorHandler(err: Error, vm: Vue, info: string) {
  throw err
}
